import React from 'react'

const About = () => {
  return (
    <div name='about' className='w-full h-screen bg-gradient-to-b from-gray-800 to-black'>
        <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
            <div className='pb-8 sm:flex flex-row'>
                <p className='text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-200 text-4xl font-bold inline border-b-4 border-gray-500'>
                    About and Experience
                </p>
            </div>
            <p className='text-xl text-white'>
            I am an active Open-Source contributor and I’ve also worked as a FrontEnd Developer intern for the company named
             elspectra where I was given the task to create components for the web app to provide effective and efficient
              user interfaces using Next.js and Typescript.
             I also learned automation using Github Actions and storybook at the company.
            </p>
            <br />
            <p className='text-xl text-white'>My experience spans both independent work on small features and
             collaborative efforts on large-scale projects. Additionally, my proficiency in client-side and server-side
              scripting languages such as NodeJS, MongoDB, and React.js allows me to develop robust and scalable
               applications that meet the highest industry standards.
               <br/>
               <br/>
            I’m also efficient at Problem Solving and have been working on my DSA.
            I’ve solved 150+ questions on leetcode and codestudio.

            </p>
        </div>
    </div>
  )
}

export default About